module.exports = __webpack_public_path__ + "assets/img/29@3x.25771545.png";